import { styled } from 'styled-components'
import Box from '@mui/material/Box'

export const StyledLayoutWrapper = styled(Box)`
height: 100vh;
`
